/**
 * Hash SHA-256 d'une string, retourné en hexadécimal (64 chars).
 * Utilise la Web Crypto API native du navigateur — aucune dépendance.
 *
 * @example
 *   await sha256Hex('fabien@taleez.com')
 *   // → "8f7e92b5...ab12" (64 chars hex)
 */
export async function sha256Hex(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const buffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Normalise un email avant hashing : trim + lowercase.
 * Garantit que "Fabien@Taleez.com  " et "fabien@taleez.com" produisent le même hash.
 */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/**
 * Hash normalisé d'un email. Retourne null si l'email est vide/invalide.
 */
export async function hashEmail(email: string | undefined | null): Promise<string | null> {
  if (!email) return null;
  const normalized = normalizeEmail(email);
  if (!normalized || !normalized.includes('@')) return null;
  return sha256Hex(normalized);
}
